export default {
      id: "icon-play-usage",
      viewBox: "0 0 320.001 320.001",
      url: "/" + "assets/sprite.svg#icon-play",
      toString: function () {
        return this.url;
      }
    }